import './DailyRembleScrollingCards.scss'

import DailyRembleCard from 'components/daily-remble/DailyRembleCard'

/**
 * Daily Remble Scrolling Cards component. Used to display daily remble video cards.
 * @param {Object} params Initial props
 * `title` - The header title (optional)
 * `emptyText` - The message to display when there are no videos (optional)
 * @returns
 */
export default function DailyRembleScrollingCards({
  dailyRembleVideos,
  title = null,
  emptyText = 'Loading...',
  returnPath = null
}) {
  return (
    <>
      {title && <h3>{title}</h3>}
      <div className='daily-remble-scrolling-card-wrapper'>
        <div className='daily-remble-scrolling-card-cards'>
          {dailyRembleVideos.length > 0 ? (
            dailyRembleVideos.map((dailyRemble, index) => (
              <DailyRembleCard
                key={dailyRemble.id || dailyRemble.ID}
                dailyRemble={dailyRemble}
                cardIndex={index}
                returnPath={returnPath}
              />
            ))
          ) : (
            <div className='no-cards'>
              <p className='mb-0'>{emptyText}</p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
